module.exports = __webpack_public_path__ + "static/media/express.2b875fbc.jpg";